module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/scentbird-box@2x_e3d5f5.png";